require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-less-talk-more-action-three-companies-weigh-in-on-diversity-and-inclusion.json") })
        }
      }, "path---blog-less-talk-more-action-three-companies-weigh-in-on-diversity-and-inclusion");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-less-talk-more-action-three-companies-weigh-in-on-diversity-and-inclusion!./.cache/json/blog-less-talk-more-action-three-companies-weigh-in-on-diversity-and-inclusion.json
// module id = 948
// module chunks = 231608221292675